import { render, staticRenderFns } from "./detail_tabs.vue?vue&type=template&id=29519cb2&lang=pug&"
import script from "./detail_tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./detail_tabs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports